import {
  SLIDE_IN_CONTAINER_POSITION,
  useSetScrollToTopOffset,
} from '@aboutyou/ui-components';
import {useEffect} from 'react';
import {useSearchResultQuestionnaire} from '../../SearchResultQuestionnaire/utils/useSearchResultQuestionnaire';
import {useShowSlideInWebCouponBanner} from './useShowSlideInWebCouponBanner';

export const useUpdateScrollToTopOffset = () => {
  const shouldShowSlideInWebCouponBanner = useShowSlideInWebCouponBanner();
  const {setScrollToTopOffset} = useSetScrollToTopOffset();

  const {shouldShowSearchResultQuestionnaire} = useSearchResultQuestionnaire();

  useEffect(() => {
    if (shouldShowSlideInWebCouponBanner) {
      // eslint-disable-next-line local-rules/set-state-in-use-effect
      setScrollToTopOffset({
        axis: 'x',
        offset: shouldShowSearchResultQuestionnaire
          ? undefined
          : SLIDE_IN_CONTAINER_POSITION,
      });
      setScrollToTopOffset({axis: 'y', offset: '40px'});
    } else {
      setScrollToTopOffset({axis: 'x', offset: undefined});
      setScrollToTopOffset({axis: 'y', offset: undefined});
    }
  }, [shouldShowSearchResultQuestionnaire, shouldShowSlideInWebCouponBanner]);
};
